import { useEffect, useMemo, useState } from 'react';
import { getPacienteInformeById } from '../api/pacientesApi';
import { PACIENTE_ACTIONS, PACIENTE_CUESTIONARIOS } from '../model/pacienteConstants';

export const usePacienteDetail = ({ idPaciente }) => {
  const [paciente, setPaciente] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!idPaciente) return;

    let isMounted = true;

    const fetchPaciente = async () => {
      try {
        const data = await getPacienteInformeById(idPaciente);
        if (isMounted) {
          setPaciente(data);
          setError(null);
        }
      } catch (fetchError) {
        if (isMounted) {
          setError(fetchError);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchPaciente();

    return () => {
      isMounted = false;
    };
  }, [idPaciente]);

  const actions = useMemo(() => PACIENTE_ACTIONS, []);
  const cuestionarios = useMemo(() => PACIENTE_CUESTIONARIOS, []);

  return {
    paciente,
    loading,
    error,
    actions,
    cuestionarios,
  };
};
